import { createSelector } from 'reselect';
import ImpcDetailsColumns from '../../containers/ImpcDetailsColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.IMPC_DETAILS_PAGE.isLoading;
export const getData = TableDefinitions.IMPC_DETAILS_PAGE.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.userData.userInfo[0].split('_'),
  ImpcDetailsColumns,
);
